module.exports = __webpack_public_path__ + "static/media/inactive.4c6b336f.svg";